export const ADD_NEW_CHAT_MESSAGE_REQUEST = 'ADD_NEW_CHAT_MESSAGE_REQUEST';

export const addNewChatMessageRequest = ( conversationId, message ) => ({
    type: ADD_NEW_CHAT_MESSAGE_REQUEST,
    payload: {
        conversationId,
        message
    }
});
